/**
 * 읽기 전용 모드 체크와 이벤트 전파 중지를 위한 공통 핸들러
 */
export const createEventHandler = <E extends React.SyntheticEvent>(
  handler: (e: E) => void,
  isReadOnly: boolean = false,
): ((e: E) => void) => {
  return (e: E): void => {
    if (isReadOnly) return
    e.stopPropagation()
    handler(e)
  }
}

/**
 * 클릭 이벤트 핸들러 생성
 */
export const createClickHandler = (
  handler: (e: React.MouseEvent) => void,
  isReadOnly: boolean = false,
): ((e: React.MouseEvent) => void) => {
  return createEventHandler(handler, isReadOnly)
}
